import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import styled from 'styled-components';

const StyledDropdown = styled.div`

  width: 100%;
  clear: both;
  display: table;
  position: relative;
  margin: 8px 0 40px;
  border-radius: 8px;
  height: 60px;

  > div:first-child {
    width: 100%;
    background-color: #fff;
    display: table-cell;
    vertical-align: middle;
    position: absolute;
    z-index: ${props => props.open ? 9 : 6};
    border-radius: 8px;
    height: auto;
    overflow: hidden;
    box-shadow: ${props => props.open ? "0px 3px 6px 3px rgba(0, 0, 0, .1)" : "0px 3px 6px 3px rgba(0, 0, 0, .05)"};
    max-height: ${props => props.open ? "1000px" : "60px"};
    -webkit-transition: all .2s ease-in-out;
    -moz-transition: all .2s ease-in-out;
    -o-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    > button {
      text-transform: uppercase;
      position: absolute;
      background: #fff;
      color: #333;
      z-index: 2;
      padding: 0 20px;
      left: 0;
      width: 100%;
      top: 0;
      width: 100%;
      height: 60px;
      i {
        position: absolute;
        right: 16px;
        top: 20px;
        width: 20px;
        height: 20px;
        svg {
          stroke-width: 4;
          stroke: #333333;
          margin: 0 auto;
        }
      }
    }

    > ul {
      margin: 0;
      list-style: none;
      overflow: hidden;
      height: auto;
      max-height: ${props => props.open ? "1000px" : "60px"};
      -webkit-transition: all .2s ease-in-out;
      -moz-transition: all .2s ease-in-out;
      -o-transition: all .2s ease-in-out;
      transition: all .2s ease-in-out;
      position:relative;
      background-color: #fff;
      left: 0;
      width: 100%;
      top: 0;
      border-radius: 8px;
      padding: 60px 0 20px;
      font-size: 0.825em;
      z-index: 1;
      text-transform: uppercase;
      li {
        color: #333;
        margin: 0;
        vertical-align: middle;
        padding: 8px 20px;
        cursor: pointer;
        -webkit-transition: all .2s ease-in-out;
        -moz-transition: all .2s ease-in-out;
        -o-transition: all .2s ease-in-out;
        transition: all .2s ease-in-out;
      }
      li:hover {
        background: #eee;
      }
    }
  }
`;

export default function Dropdown (props) {
  const {data, selected, onChange} = props;
  const [open, setOpen] = useState(false);

  return (
    <StyledDropdown open={open}>
      <div>
        <Button icon={open ? "up" : "down"} label={selected || "Please select"} onClick={() => setOpen(!open)} transparent/>
        <ul>
        {data.map((item, index) =>
          <li key={index} onClick={() => {onChange(item); setOpen(false);}}>{item}</li>
        )}
        </ul>
      </div>
    </StyledDropdown>
  )
}

Dropdown.propTypes = {
  data: PropTypes.array
};
